export default __webpack_public_path__ + "static/media/18.94e6f317.png";